export enum ApiCredentialScope {
  OrdersRead = 'ordersRead',
  OrdersCreate = 'ordersCreate',
  OrdersCancel = 'ordersCancel',
  WebhooksManage = 'webhooksManage',
}
